module.exports = __webpack_public_path__ + "static/media/LandingPage-Surveys-MouseOver.890c4582.png";